<style lang="scss" type="text/scss">
  ul.sub-menu {
    list-style: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  ul li {
    display: inline-flex;
    justify-content: center;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    font-size: 15px;
    margin-right: 16px;
    color: #4c4c4b;
    text-align: center;
    padding: 16px 16px;
  }

  ul li :global(a) {
    color: #4c4c4b;
  }



  .sub-menu a {
    color: #4c4c4b !important;
  }

  ul li.active {
    border-bottom: 3px solid #ff6452;
    color: #ff6452;
  }

  ul li.active :global(a) {
    color: #ff6452;
  }

  ul li.a:hover {
    text-decoration: none;
  }

  .steps {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    padding: 0;
    margin: 16px 0;
  }

  .prev,
  .next {
    background: #fbfbfb;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }

  .prev {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: 1px solid darken(#fbfbfb, 2);
  }

  .next {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 1px solid darken(#fbfbfb, 2);
  }

  .steps-fixed {
    background: #fff;
    padding: 0;
    margin: 16px 0;
    top: -116px;
    z-index: 9999;
    position: fixed;
    width: calc(80%);
    left: calc(20%);
    box-shadow: -1px 0 62px -6px rgba(0, 0, 0, 0.22);
    transition: all 0.2s;
  }

  .steps-fixed.show {
    top: -16px;
  }

  /*
  
  */
</style>

<script>
  import { onMount, onDestroy } from 'svelte';
  import Link from '../../utils/link';
  export let items = [];
  export let active;

  let fixed = false;

  function getWidth() {}

  let width = `calc(${100 / items.length}% - 16px)`;

  function next() {
    const i = items.findIndex(item => item.id === active);
    if (i !== items.length - 1) {
      items[i + 1].click();
    } else {
      items[0].click();
    }
  }

  function prev() {
    const i = items.findIndex(item => item.id === active);
    if (i !== 0) {
      items[i - 1].click();
    } else {
      items[items.length - 1].click();
    }
  }

  function onScroll() {
    if (window.scrollY > 232) {
      fixed = true;
    } else {
      fixed = false;
    }
  }

  onMount(() => {
    window.addEventListener('scroll', onScroll);
  });
</script>


<div class="steps">
    <div class="grid-x">
      
      <div class="cell small-12">
        <ul class="sub-menu">
          {#each items as item, i}
          <li
            style="width:{width}"     
            class:active="{item.id === active}"
          >
          <Link href={item.link}>{item.label}</Link>
          </li>
          {/each}
        </ul>
      </div>
      
    </div>
  </div>
  
  <div class="steps-fixed" class:show="{fixed}">
    <div class="grid-x">
      
      <div class="cell small-12">
        <ul class="sub-menu">
          {#each items as item, i}
          <li
            style="width:{width}"
            on:click="{item.click}"
            class:active="{item.id === active}"
          >
          <Link href={item.link}>{item.label}</Link>
          </li>
          {/each}
        </ul>
      </div>
      
    </div>
  </div>